import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PORTAL_ROUTES } from 'utils/constants';
import ChargesDetail from 'pages/Billing/Charges/Detail'

const ChargesShow = () => {
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <Link
          to={PORTAL_ROUTES.BILLING}
          className="inline-flex items-center justify-center rounded-xl text-slate-600 p-2 hover:bg-base-200 border border-base-200/80 bg-base-100 shadow-2xs transition-colors"
          title="Back to Billing"
        >
          <ArrowLeft size={18} />
        </Link>
        <div>
          <h1 className="text-2xl font-bold text-secondary-900 leading-none">Manual Charge</h1>
          <p className="text-xs text-slate-400 mt-1">Review charge summary and enter card details below</p>
        </div>
      </div>

      <ChargesDetail />
    </div>
  );
};

export default ChargesShow;
